import gql from 'graphql-tag';

export const createAudience = gql`
  mutation createAudience($audience: CreateAudienceInput) {
    createAudience(audience: $audience) {
      id
      createdAt
      updatedAt
      createdBy
      updatedBy
      name
      archived
      createdByChannel
      managementChannels
      shareChannels
      contentToTarget
      channelTargetingRules {
        id
        name
        channelId
        audienceId
      }
      groupRoleTargetingRules {
        id
        name
        groupRoleId
        audienceId
      }
    }
  }
`;
